"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var web3_shim_1 = require("./web3-shim");
exports.Web3Shim = web3_shim_1.Web3Shim;
var interface_adapter_1 = require("./interface-adapter");
exports.InterfaceAdapter = interface_adapter_1.InterfaceAdapter;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@truffle/interface-adapter/dist/index.js
// module id = 1499
// module chunks = 0